import { useEffect, useState } from 'react'
import { CollapsibleSection } from './CollapsibleSection'
import { parseFirmwareVersion, parseHardwareVersion, roundToDecimal } from '../common/utils'
import { api } from '../services'
import { DeviceInfo } from '../common/enums'

interface Props {
  device: DeviceInfo
  showBatteryVoltage?: boolean
  open?: boolean
}

export function DeviceDetails({ device, showBatteryVoltage = true, open = false }: Props) {
  const [data, setData] = useState<string[][]>([])
  const [lastBatteryReading, setLastBatteryReading] = useState(0)
  const [title, setTitle] = useState('RIC Name: ')

  useEffect(() => {
    sync()
    async function sync() {
      const response = await api.getBatteryReadings(device.sigfoxId, 0, Math.floor(Date.now() / 1000), 1)
      const batteryReadings = response.data
      const lastTimestamp = Object.keys(batteryReadings).sort().reverse()[0]
      const lastReading = batteryReadings[lastTimestamp]
      setLastBatteryReading(lastReading)
    }
  }, [device])

  useEffect(() => {
    if (device) {
      setTitle('RIC Name: ' + device.deviceName)

      const data = [
        [
          `Serial Number: ${device.serialNumber}`,
          `WISOL ID: ${device.wisolId}`,
          `Hardware: ${parseHardwareVersion(device.hardwareNumber)}`,
          `Firmware: ${parseFirmwareVersion(device.firmwareVersion)}`,
        ],
      ]

      if (showBatteryVoltage) {
        data.push([`Battery Reading: ${roundToDecimal(lastBatteryReading, 2)} V`])
      }

      setData(data)
    }
  }, [device, lastBatteryReading, showBatteryVoltage])

  return (
    <CollapsibleSection title={title} open={open}>
      <table className={tailwind.table}>
        <tbody>
          {data.map((row, index) => (
            <tr key={index} className={index % 2 === 0 ? tailwind.even : tailwind.odd}>
              {row.map((item, index) => (
                <td key={index}>{item}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </CollapsibleSection>
  )
}

const tailwind = {
  table: 'table-fixed w-full',
  even: 'text-black text-l font-regular h-10 py-2.5 pl-4 pr-4 w-full border-b bg-[#f9f9f9]',
  odd: 'text-black text-l font-regular h-10 py-2.5 pl-4 pr-4 w-full border-b bg-[#fff]',
}
